import * as bootstrap from 'bootstrap';

export default function initMapMarkers() {
  const dataUrl = window.location.origin + '/api/v1/experience-map-poi';

  fetch(dataUrl)
    .then((response) => response.json())
    .then((markers) => {
      initPopup(markers.data);
    })
    .catch((error) => console.log(error.message));

  function initPopup(markers) {
    const activeClass = 'popover-active';
    const eventName = 'mapChanged';

    markers.forEach((marker) => {
      const popupBtn = document.querySelector(`[id="${marker.id}"]`);

      if (popupBtn) {
        // This class is used to use cursor: pointer
        popupBtn.classList.add('has-popup');

        const popupOptions = {
          container: '#map-wrapper',
          placement: 'top',
          html: true,
          content: createPopupTemplate(marker),
        };

        const popupInstance = new bootstrap.Popover(popupBtn, popupOptions);

        document.addEventListener(eventName, () => {
          popupInstance.update();
        })

        popupBtn.addEventListener('shown.bs.popover', function () {
          this.classList.add(activeClass);
        });

        popupBtn.addEventListener('hidden.bs.popover', function () {
          this.classList.remove(activeClass);
        });
      }
    });
  }

  function createPopupTemplate({ image, link, text, title }) {
    return `
      <div class="popup-card">
        <div class="popup-card-media">
          <img class="popup-card-img" src="${image.src}" alt="${image.alt}"/>
          <h3 class="popup-card-title">${title}</h3>
        </div>
        <div class="popup-card-body">
          <p>${text}</p>
          ${
            link.text
              ? `
            <a href="${link.href}" class="btn btn-light btn-sm">
              ${link.text}
              <span class="icon icon-arrow-right"></span>
            </a>
          `
              : ''
          }
        </div>
      </div>
    `;
  }
}
